<template>
    <div class="modal" id="ProductpricingOrderModal" ref="ProductpricingOrderModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hideModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="pricing-body">
                        <div class="bordered-title">
                            <span class="fa fa-dollar"></span>
                            <h3>طلب شراء هذا المنتج</h3>
                        </div>
                        <div class="body f-f-jf-flat">
                            <form class="noPadMarginForms" id="pricingOrderForm">
                                <input v-model="order.Fullname" class="form-control" placeholder="الاسم الكامل..." required=""
                                       type="text">
                                <input v-model="order.Email" class="form-control" placeholder="البريد الالكتروني..." required=""
                                       type="email">
                                <input v-model="order.Phone1" class="form-control onlyNumbers" placeholder="رقم الهاتف..."
                                       required="" type="text">
                                <input v-model="order.Amount" class="form-control onlyNumbers" placeholder="الكمية..."
                                       required="" type="text">
                                <textarea class="form-control noresize" v-model="order.Description"
                                          placeholder="تفاصيل طلب التسعير..." style="height:250px"
                                          required=""></textarea>

                                <button class="btn btn-custom col-sm-4 col-xs-12" @click="submitOrder">
                                    <span class="fa fa-send marginl10"></span>
                                    <span>أرسل</span>
                                </button>

                                <div class="clearfix margin15 f-f-jf-flat"></div>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ProductPricingOrderModal',


        data: () => ({
            order: {
                ProductId: null,
                Fullname: null,
                Address: null,
                Email: null,
                Phone1: null,
                Description:  null,
                Amount: null,
            }
        }),

        methods: {
            showModal(id) {
                $("#ProductpricingOrderModal").modal('show');
                this.order.ProductId = id;
            },

            hideModal() {
                $("#ProductpricingOrderModal").modal('hide');
            },

            validateOrder() {
                if (this.isNullOrEmpty(this.order.ProductId)) return false;
                if (this.isNullOrEmpty(this.order.Fullname)) return false;
                if (this.isNullOrEmpty(this.order.Description)) return false;
                if (this.isNullOrEmpty(this.order.Email)) return false;
                if (this.isNullOrEmpty(this.order.Phone1)) return false;
                if (this.isNullOrEmpty(this.order.Amount)) return false;
                if (!this.validateEmail(this.order.Email)) return false;
                if (/\D/.test(this.order.Phone1)) return false;
                if (/\D/.test(this.order.Amount)) return false;

                return true;
            },

            submitOrder() {
                if (!this.validateOrder()) return;

                NProgress.start();
                axios.post(apiHost + "/products/" + this.order.ProductId + "/place-order", this.order)
                    .then((response) => {
                        NProgress.done();
                        this.hideModal();
                    });
            }
        },

        mounted() {
            $(this.$refs.ProductpricingOrderModal).on("hide.bs.modal", () => {
                $('.modal .modal-dialog').attr('class', 'modal-dialog  zoomOut  animated');
            });
            $(this.$refs.ProductpricingOrderModal).on("show.bs.modal", () => {
                $('.modal .modal-dialog').attr('class', 'modal-dialog  zoomIn  animated');
            });
        }

    }
</script>
<style lang="scss">
    @import "src/assets/sass/shared.scss";
    @import "animate.css/animate.min.css";

    #ProductpricingOrderModal {
        overflow: auto;
        background-color: rgba(#fff, 0.8);
        z-index: 99999;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        margin: 0 auto;
        @include animation-duration(0.6s);
        overflow-x: hidden;
        overflow-y: auto;
        .modal-dialog {
            width: 100%;
            height: 100%;
            margin: 0px;
            .modal-content {
                background-color: rgba(#fff, 0.8);
                box-shadow: none;
                border: 0px;
                direction: $dir;

                .modal-header {
                    border-bottom: 0px;
                    background-color: rgba(#fff, 0.8);

                    .close {
                        span {
                            font-size: 40px;
                            color: $main-color;
                        }
                    }
                }
                .modal-body {
                    border-bottom: 0px;
                    background-color: rgba(#fff, 0.6);
                    .pricing-body {
                        width: 70%;
                        margin: 0px auto;
                        @media(max-width: 767px) {
                            width: 70%;
                        }
                        @media(max-width: 480px) {
                            width: 90%;
                        }
                    }
                    overflow: auto;
                    .form-control {
                        margin-bottom: 5px;
                        height: 40px;
                    }
                }
            }
        }

    }

    .bordered-title {

        @include text-align($dir);
        margin-bottom: 50px;
        border-bottom: 1px solid #ccc;
        h3 {
            display: inline-block;
        }
    }

    .modal-open {
        padding-right: 0px !important;
    }


</style>



// WEBPACK FOOTER //
// src/components/products/pricing-order.vue